import {Component, input} from '@angular/core';
import {DualRange} from "../../../../../shared/components/dual-range/dual-range";
import {FiltersSidebarFilterComponent} from "../filters-sidebar-filter/filters-sidebar-filter.component";
import {ResultTableService} from '../../../services/result-table.service';

@Component({
  selector: 'app-filters-sidebar-warranty-filter',
    imports: [
        DualRange,
        FiltersSidebarFilterComponent
    ],
  templateUrl: './filters-sidebar-warranty-filter.component.html',
  styleUrl: './filters-sidebar-warranty-filter.component.css',
})
export class FiltersSidebarWarrantyFilterComponent {
  label = input.required<string>()
  key = input.required<string>()

  constructor(private resultsTableService: ResultTableService) {
  }

  formatMileage = (value: number): string => {
    if (value === 0) return 'No warranty';
    return value >= 1000 ? `${value / 1000}k mi` : `${value} mi`;
  };

  rangeChange(event: any) {
    if (event.max) {
      this.resultsTableService.updateFilter(this.key(), {min: event.min, max: event.max});
    } else {
      this.resultsTableService.clearFilter(this.key())
    }
  }
}
